import { render, staticRenderFns } from "./Onhold.vue?vue&type=template&id=09ea1938&scoped=true&"
import script from "./Onhold.vue?vue&type=script&lang=js&"
export * from "./Onhold.vue?vue&type=script&lang=js&"
import style0 from "./Onhold.vue?vue&type=style&index=0&id=09ea1938&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ea1938",
  null
  
)

export default component.exports